<script>
  import VProgressCircular from '../../node_modules/vuetify/es5/components/VProgressCircular/VProgressCircular'

  export default {
    name: 'debt-wheel',
    extends: VProgressCircular,
    props: {
      segments: {
        type: Number,
        default: 0
      }
    },
    computed: {
      segmentsStroke() {
        return '1, ' + ((this.circumference / this.segments) - 1)
      }
    },
    methods: {
      genSegments(name, offset) {
        return this.$createElement('circle', {
          class: `progress-circular__${name}`,
          attrs: {
            fill: 'transparent',
            cx: 2 * this.viewBoxSize,
            cy: 2 * this.viewBoxSize,
            r: this.radius,
            'stroke-width': this.strokeWidth,
            'stroke-dasharray': offset,
            'stroke-dashoffset': 0
          }
        })
      },
      genSvg: function genSvg() {
        var children = [this.indeterminate || this.genCircle('underlay', 0), this.genCircle('overlay', this.strokeDashOffset)];

        if (this.segments > 0 && this.segments < 50) {
          children.push(this.genSegments('overlay-segments', this.segmentsStroke))
        }

        return this.$createElement('svg', {
          style: this.svgStyles,
          attrs: {
            xmlns: 'http://www.w3.org/2000/svg',
            viewBox: "".concat(this.viewBoxSize, " ").concat(this.viewBoxSize, " ").concat(2 * this.viewBoxSize, " ").concat(2 * this.viewBoxSize)
          }
        }, children);
      }
    }
  }
</script>
